import { Can } from 'components/Can';
import DetailM06 from 'features/MidtermReview/pages/DetailM06';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

export default function MidtermreviewDetailM06Page() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <Can do="read" on="midterm_review">
          <DetailM06 />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}
